import { ConfirmationWithCommentDialogState } from ".";

export const ConfirmationWithCommentDialogInitialState: ConfirmationWithCommentDialogState =
  {
    isShow: false,
    type: "",
    title: "",
    message: "",
    layout: {
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonTitle: "CANCEL",
      showNgButton: false,
      ngButtonTitle: "REJECT",
      reqCommClickNg: true,
      okButtonTitle: "OK",
      reqCommClickOk: true,
    },
    comment: "",
    isValid: true,
  };
